export default __webpack_public_path__ + "fcb91fef12ab549b8b774903250a8611.png";